import Icon from '../components/Icon.vue'

Icon.register({
  'cloud-sun': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M575.2 325.7c37.6 13 64.8 48.3 64.8 90.4 0 53-43 96-96 96h-272c-53 0-96-43-96-96 0-50.6 39.3-91.6 88.9-95.3-0.2-2.9-0.9-5.7-0.9-8.7 0-61.9 50.2-112 112-112 45.4 0 84.3 27.2 101.9 66 9.9-6.2 21.5-10 34.1-10 35.3 0 64 28.7 64 64 0 1.9-0.6 3.7-0.8 5.6zM144.8 303.1c10.6 10.6 22.9 18.6 36 24-9.6 9.8-17.5 21.1-23.6 33.5l-76.1 25.3c-11.9 3.9-23.2-7.3-19.2-19.2l29.3-87.8-82.8-41.4c-11.2-5.6-11.2-21.5 0-27.1l82.8-41.5-29.3-87.8c-3.9-11.8 7.4-23.1 19.2-19.2l87.9 29.3 41.4-82.8c5.6-11.2 21.6-11.2 27.1 0l41.5 82.8 87.8-29.3c11.9-3.9 23.2 7.3 19.2 19.2l-29.8 88.9c-10.6 1.5-20.9 3.8-30.7 7.5-5.4-11.8-12.6-23-22.3-32.7-43.7-43.7-114.7-43.7-158.4 0-43.7 43.6-43.7 114.6 0 158.3zM140 223.9c0-46.3 37.7-83.9 84-83.9 34 0 63.3 20.4 76.5 49.5-36.4 22.5-62 60.7-67.4 105-8.9 2.9-17.2 7-25.2 11.7-38.6-7.5-67.9-41.5-67.9-82.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cloud-sun.js
// module id = 1215
// module chunks = 0